module.exports = __webpack_public_path__ + "static/media/testimonio3.0bdc34ad.jpg";